const doc = [({"da":({"js":({"admin":({"comments":({"index":({"the_comment_was_added":"Kommentaren blev tilføjet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;